<ion-content no-bounce padding-horizontal>
  @if (!isOnline()) {
    <div class="error-network">
      <span class="error-network-container">
        <i class="icon-warning"></i>
        <span>{{"NoAccessInternet" | translate}}</span>
      </span>
    </div>
  } @else if (showDotsSignal()) {
    <div class="page-header">
      <div class="page-title">
        {{'Tenants' | translate}}
        {{('Loading' | translate)}}
      </div>
    </div>
    <div class="empty-state">
      <div class="loader loader--sm loader--compact"><span></span></div>
    </div>
  } @else {
    <app-header
      [iconName]="'menu'"
      [title]="null"
      [menuToggleRight]="true"
      [showErrorMessageNetwork]="true">
    </app-header>
    <ion-refresher (ionRefresh)="refreshTenantList($event)" slot="fixed">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <div class="page-header">
      <div class="page-title">
        {{'SelectTenantRedirect' | translate | stringular: 'Printix' }}
      </div>
    </div>

    @if (tenantListSignal().length > 0) {
      <div class="tenant-list-container">
        @for (tenant of tenantListSignal() | orderBy: 'tenantData.hostingDomain'; track $index) {
          <div class="list-content-tenantselect width90 mb15">
            <div class="list-row list__item list__item--clickable">
              <button (click)="selectTenant(tenant)" class="list-cell actionbutton text-center width100 p10">
                <span>{{tenant.tenantData.hostingDomain}}</span>
              </button>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="text-center">
      {{"None" | translate}}
      </div>
    }
  }
</ion-content>